import type { CleaningAreaRowContentBlockProps } from '../../../../../../../../types/CleaningAreaList.types';
import {
  CleaningAreaOrderBadge,
  CleaningAreaRowCheckboxWrapper,
  CleaningAreaRowContent,
  CleaningAreaRowDragHandle,
  CleaningAreaRowText,
} from './CleaningAreaRowContentBlock.styles';
import { KccCheckbox } from 'lib/components/KccCheckbox/KccCheckbox';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

export const CleaningAreaRowContentBlock = ({
  area,
  position,
  isDraggable,
  onToggleArea,
  disabled,
  dragHandleProps,
  isOverlayDragging,
  isDraggingSource,
}: CleaningAreaRowContentBlockProps): JSX.Element => {
  const isSelected = position !== null;
  // Reuse the same greyed-out treatment as the dragging-source state for the order badge and
  // checkbox when the whole area list is read-only (e.g. robot offline).
  const isMuted = isDraggingSource || disabled;

  return (
    <>
      <CleaningAreaRowDragHandle
        $active={isDraggable}
        $isDragging={isOverlayDragging}
        $isDraggingSource={isDraggingSource}
        {...(dragHandleProps?.attributes ?? {})}
        {...(dragHandleProps?.listeners ?? {})}
        onClick={(event): void => event.stopPropagation()}
      >
        <SvgIcon name="drag" />
      </CleaningAreaRowDragHandle>

      <CleaningAreaRowContent align="center">
        <span style={{ visibility: isSelected ? 'visible' : 'hidden' }}>
          <CleaningAreaOrderBadge $isDraggingSource={isMuted} count={position !== null ? position + 1 : 1} />
        </span>
        <CleaningAreaRowText $isSelected={isSelected} $isDraggingSource={isDraggingSource} ellipsis>
          {area.name}
        </CleaningAreaRowText>
      </CleaningAreaRowContent>

      <CleaningAreaRowCheckboxWrapper $isDraggingSource={isMuted} onClick={(event): void => event.stopPropagation()}>
        <KccCheckbox checked={isSelected} disabled={disabled} onChange={(): void => onToggleArea(area.id)} />
      </CleaningAreaRowCheckboxWrapper>
    </>
  );
};
